import React, {useCallback} from "react";
import {AppBar, AppBarProps, Container, IconButton, Toolbar, Typography, useMediaQuery} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import {ArrowBackDesktop} from "~/ui/icons";


export type TitleAppBarProps = AppBarProps & {
    title?: string
    actions?: any
    onBack?: () => void
    backIcon?: any
    back?: boolean
}

const defaultProps = {
    back: true
}

export const TitleAppBar = (props: TitleAppBarProps) => {
    const {title, onBack, backIcon, actions, back, ...other} = props;
    const history = useHistory();

    const handleBack = useCallback(() => {
        if (onBack) {
            onBack();
        } else {
            history.goBack();
        }
    }, [history, onBack])


    return (
        <AppBar position="fixed" color="inherit" {...other}>
            <Container disableGutters>
                <Toolbar>
                    {back && (
                        <IconButton onClick={handleBack} color="primary" edge="start">
                            {backIcon || <ArrowBack/>}
                        </IconButton>
                    )}
                    <Typography variant="menuTitle" style={{ flexGrow: 1 }} color="primary" display="block" noWrap={true}>
                        {props.title}
                    </Typography>
                    {actions}
                </Toolbar>
                {props.children && (
                    <div>
                        {props.children}
                    </div>
                )}
            </Container>
        </AppBar>
    );
}
TitleAppBar.defaultProps = defaultProps;
